import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import addAutoAnswer from "./components/addAutoAnswer.vue";
import { mapActions } from "vuex";
import { customConfig, delAutoReplyMsg } from "@/api/customerCenter/customerCenter";
export default {
  name: "customerCustomization",
  components: {
    addAutoAnswer: addAutoAnswer
  },
  data: function data() {
    return {
      searchData: {},
      // gameAllList: [],
      tableData: []
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getGameData();

            case 2:
              _this.getData();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                customConfig(_this2.searchData).then(function (res) {
                  if (res.code == 200) {
                    res.data.forEach(function (item) {
                      var game = _this2.gameAllList.find(function (b) {
                        return b.game_mark == item.game;
                      });

                      item.game_name = game ? game.game_name : '';
                    });
                    _this2.tableData = res.data;
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getGameData: function getGameData(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch("d2admin/game/GameList");

              case 2:
                query = _context3.sent;
                _this3.gameAllList = query || [];

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return delAutoReplyMsg({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this4.getData();

                    _this4.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    }
  }
};